class LookupType {
  static getMemberStatusTypes(): string {
    return `odata/memberstatustypes`;
  }
  static getZoneTypes(): string {
    return `odata/zonetypes`;
  }
  static getJobCategoryTypes(): string {
    return `odata/memberjobcategorytypes`;
  }
  static getGenderTypes(): string {
    return `odata/gendertypes`;
  }
  static getLanguageTypes(): string {
    return `odata/languagetypes`;
  }
  static getCountryTypes(): string {
    return `odata/countrytypes`;
  }
  static getMemberTypes(): string {
    return `odata/membertypes`;
  }
  static getMemberEmployerStatusTypes(): string {
    return `odata/memberemployerstatustypes`;
  }
  static getApplicationStatusTypes(): string {
    return `odata/applicationstatustypes`;
  }
  static getApplicationTaskStatusTypes(): string {
    return `odata/applicationtaskstatustypes`;
  }
  static getFacilityTypes(): string {
    return `odata/facilitytypes`;
  }
  static getFacilityStatusTypes(): string {
    return `odata/facilitystatustypes`;
  }
  static getGolfCourseTypes(): string {
    return `odata/golfcoursetypes`;
  }
  static getRaceTypes(): string {
    return `odata/racetypes`;
  }
  static getEthnicityTypes(): string {
    return `odata/ethnicitytypes`;
  }
  static getPronounTypes(): string {
    return `odata/pronountypes`;
  }
  static getLgbtStatusTypes(): string {
    return `odata/lgbtq2splusstatustypes`;
  }
  static getIndigenousStatusTypes(): string {
    return `odata/indigenousstatustypes`;
  }
  static getIndigenousTypes(): string {
    return `odata/indigenoustypes`;
  }
  static getDisabilityStatusTypes(): string {
    return `odata/disabilitystatustypes`;
  }
  static getDisabilityTypes(): string {
    return `odata/disabilitytypes`;
  }
  static getEventStatusTypes(): string {
    return `odata/eventstatustypes`;
  }

  static getEventTypes(): string {
    return `odata/eventtypes`;
  }

  static getMemberClassificationTypes() {
    return 'odata/memberclassificationtypes';
  }
  static getEventRegistrationTypes(): string {
    return `odata/eventregistrationtypes`;
  }
  static getEventRegistrationStatusTypes(): string {
    return `odata/eventregistrationstatustypes`;
  }
  static getGlAccountTypes(): string {
    return `odata/glaccounttypes`;
  }
  static getInvoiceTypes(): string {
    return `odata/invoicetypes`;
  }
  static getInvoiceStatusTypes(): string {
    return `odata/invoicestatustypes`;
  }
  static getEventRegistrantTypes(): string {
    return `odata/eventregistranttypes`;
  }
  static getAlertStatusTypes(): string {
    return `odata/alertstatustypes`;
  }
}

class Facility {
  static getFacilities(): string {
    return `odata/facilities`;
  }
  static getFacility(facilityId: number): string {
    return `odata/facilities/${facilityId}`;
  }
  static createFacility(): string {
    return `facilities`;
  }
  static getFacilityContacts(facilityId: number): string {
    return `odata/facilities/${facilityId}/contacts`;
  }
  static createFacilityContact(facilityId: number): string {
    return `facilities/${facilityId}/contacts`;
  }
}

class MembershipApplicationTask {
  static update(applicationTaskId: number): string {
    return `membershipapplicationtasks/${applicationTaskId}`;
  }
  static addUpload(applicationTaskId: number): string {
    return `membershipapplicationtasks/${applicationTaskId}/uploads`;
  }
  static removeUpload(applicationTaskId: number, uploadId: number): string {
    return `membershipapplicationtasks/${applicationTaskId}/uploads/${uploadId}`;
  }
}

class MembershipReapplicationApplicationTask {
  static update(applicationTaskId: number): string {
    return `membershipreapplicationapplicationtasks/${applicationTaskId}`;
  }

  static addUpload(applicationTaskId: number): string {
    return `membershipreapplicationapplicationtasks/${applicationTaskId}/uploads`;
  }
  static removeUpload(applicationTaskId: number, uploadId: number): string {
    return `membershipreapplicationapplicationtasks/${applicationTaskId}/uploads/${uploadId}`;
  }
}

class MembershipReinstatementApplicationTask {
  static update(applicationTaskId: number): string {
    return `membershipreinstatementapplicationtasks/${applicationTaskId}`;
  }

  static addUpload(applicationTaskId: number): string {
    return `membershipreinstatementapplicationtasks/${applicationTaskId}/uploads`;
  }
  static removeUpload(applicationTaskId: number, uploadId: number): string {
    return `membershipreinstatementapplicationtasks/${applicationTaskId}/uploads/${uploadId}`;
  }
}

class MemberEmployer {
  static getMemberEmployers(memberId: number): string {
    return `odata/members/${memberId}/memberemployers`;
  }
  static getMemberEmployer(memberId: number, memberEmployerId: number): string {
    return `odata/members/${memberId}/memberemployers/${memberEmployerId}`;
  }
  static create(memberId: number): string {
    return `members/${memberId}/memberemployers`;
  }
  static update(memberId: number, memberEmployerId: number): string {
    return `members/${memberId}/memberemployers/${memberEmployerId}`;
  }
}

export class Endpoints {
  static LookupType = LookupType;
  static Facility = Facility;
  static MembershipApplicationTask = MembershipApplicationTask;
  static MembershipReapplicationApplicationTask = MembershipReapplicationApplicationTask;
  static MembershipReinstatementApplicationTask = MembershipReinstatementApplicationTask;
  static MemberEmployer = MemberEmployer;
}
